import {Routes} from '@angular/router';
import {canMatchAuthenticated} from './auth/classes/canMatchAuthenticated';
import {NotFoundComponent} from './core/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'users',
    loadChildren: () => import('./users/users.routes').then(m => m.USERS_ROUTES),
    canMatch: [canMatchAuthenticated(['admin'])]
  },
  {
    path: 'events',
    loadChildren: () => import('./events/events.routes').then(m => m.EVENTS_ROUTES),
    canMatch: [canMatchAuthenticated()]
  },
  {
    path: 'profile',
    loadChildren: () => import('./user-profile/user-profile.routes').then(m => m.USER_PROFILE_ROUTES),
    canMatch: [canMatchAuthenticated()]
  },
  {
    path: 'help',
    loadChildren: () => import('./support/support.routes').then(m => m.SUPPORT_ROUTES),
    canMatch: [canMatchAuthenticated()]
  },
  {
    path: 'payments',
    loadChildren: () => import('./payment/payment.routes').then(m => m.PAYMENT_ROUTES),
    canMatch: [canMatchAuthenticated()]
  },
  {
    path: 'user-lists',
    loadChildren: () => import('./user-lists/user-lists.routes').then(m => m.USER_LISTS_ROUTES),
    canMatch: [canMatchAuthenticated(['admin'])]
  },
  // {
  //   path: 'test',
  //   loadChildren: () => import('./tester/tester.module').then(m => m.TesterModule),
  //   canMatch: [canMatchAuthenticated()]
  // },
  // {
  //   path: 'communications',
  //   loadChildren: () => import('./communications/communications.module').then(m => m.CommunicationsModule),
  //   canMatch: [canMatchAuthenticated(['admin'])]
  // },
  {
    path: 'events-admin',
    loadComponent: () => import('./admin/events-admin/events-admin.component').then(mod => mod.EventsAdminComponent),
    canMatch: [canMatchAuthenticated(['admin'])]
  },
  {
    path: 'form-builder',
    loadChildren: () => import('./form-builder/form-builder.routes').then(m => m.FORM_BUILDER_ROUTES),
    canMatch: [canMatchAuthenticated(['admin'])]
  },
  {
    path: 'templates',
    loadChildren: () => import('./html-template-editor/html-template-editor.routes').then(m => m.HTML_TEMPLATE_EDITOR_ROUTES),
    canMatch: [canMatchAuthenticated(['admin'])]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'promo-code',
    loadChildren: () => import('./promo-code/promo-code.routes').then(m => m.PROMO_CODE_ROUTES),
    canMatch: [canMatchAuthenticated(['admin'])]
  },
  {
    path: 'crm-log',
    loadChildren: () => import('./crm-log/crm-log.routes').then(m => m.CRM_LOG_ROUTES),
    canMatch: [canMatchAuthenticated(['admin'])]
  },
  {
    path: 'legal',
    loadChildren: () => import('./legal/legal.routes').then(m => m.LEGAL_ROUTES)
  },
  {
    path: 'not-found', component: NotFoundComponent
  },
  // {
  //   path: 'dev-test',
  //   loadChildren: () => import('./dev-test/dev-test.module').then(m => m.DevTestModule),
  //   canMatch: [canMatchAuthenticated()],
  //   data: {
  //     directNavigation: true
  //   }
  // },
  {path: '', pathMatch: 'full', redirectTo: 'events'},
  {path: '**', component: NotFoundComponent}
];
